import { UserProfile } from "common";


export class UserProfileValidation {
    public Valid: boolean;
    public UserProfile: UserProfile;
  }
